export interface Module {
  title: string
  body: string
  /** Spine color of the matching book in the box-set mockup */
  color: string
}

export const modules: Module[] = [
  {
    title: 'MODULE 1 — WELD INSPECTION FUNDAMENTALS & JOINT CONFIGURATION ATLAS',
    body: 'Understand welding processes, joint configurations, weld geometry, welding positions, technical symbols, fabrication drawings, WPS documentation, and inspection preparation through annotated diagrams, joint comparisons, dimensional references, and professional inspection checklists.',
    color: 'rgb(var(--color-module-1))',
  },
  {
    title: 'MODULE 2 — WELD DEFECTS & DISCONTINUITIES VISUAL IDENTIFICATION ATLAS',
    body: 'Recognize cracks, porosity, undercut, overlap, incomplete penetration, lack of fusion, inclusions, underfill, excessive reinforcement, and other discontinuities through annotated illustrations, cross-sectional diagrams, visual comparisons, and structured identification references.',
    color: 'rgb(var(--color-module-2))',
  },
  {
    title: 'MODULE 3 — VISUAL WELD INSPECTION PROCEDURES & PRECISION MEASUREMENT SYSTEM',
    body: 'Explore pre-weld, in-process, and final visual inspection workflows, weld gauge techniques, fillet measurements, reinforcement, undercut depth, misalignment, dimensional verification, and field documentation through illustrated procedures and practical inspection tools.',
    color: 'rgb(var(--color-module-3))',
  },
  {
    title: 'MODULE 4 — NON-DESTRUCTIVE TESTING METHODS & WELD INDICATION INTERPRETATION ATLAS',
    body: 'Understand ultrasonic testing, radiographic testing, magnetic particle testing, liquid penetrant testing, phased array techniques, examination limitations, and representative NDT indications through annotated technical illustrations, method comparisons, and interpretation examples.',
    color: 'rgb(var(--color-module-4))',
  },
  {
    title: 'MODULE 5 — WELD QUALITY EVALUATION, CODE REQUIREMENTS & ACCEPTANCE ASSESSMENT',
    body: 'Explore weld quality assessment, AWS, ASME, and ISO code navigation, discontinuity evaluation, dimensional requirements, inspection traceability, nonconformance documentation, and acceptance assessment workflows using structured reference charts and professional evaluation tools.',
    color: 'rgb(var(--color-module-5))',
  },
  {
    title: 'MODULE 6 — REAL-WORLD WELD INSPECTION CASE STUDIES, REPORTS & FIELD APPLICATION SYSTEM',
    body: 'Apply inspection knowledge through realistic structural steel, piping, and industrial fabrication scenarios, documented findings, weld mapping, corrective action workflows, inspection reports, reinspection records, and practical quality control examples.',
    color: 'rgb(var(--color-module-6))',
  },
]
